module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-timber-hayman-0.aad8c3dc.jpg";